// extracted by mini-css-extract-plugin
export default {"container":"messagebox_container__qa9K2","button-container":"messagebox_button-container__E8HpX"};